theme.CollectionFilters = (function() {
  var selectors = {
    filterForm: '.filter-form',
    filterLinks: 'a[href*="/collections/"]',
    tagRemoveLinks: '.tag--remove a'
  };

  function CollectionFilters() {
    this.init();
  }

  CollectionFilters.prototype = Object.assign({}, CollectionFilters.prototype, {
    init: function() {
      // Handle filter form clicks
      document.querySelectorAll(selectors.filterForm).forEach(form => {
        form.addEventListener('click', this.onFilterClick.bind(this));
      });

      // Handle tag removal clicks
      document.querySelectorAll(selectors.tagRemoveLinks).forEach(link => {
        link.addEventListener('click', this.onTagRemoveClick.bind(this));
      });
    },

    onFilterClick: function(evt) {
      const link = evt.target.closest('a[href]');
      if (!link) return;

      evt.preventDefault();
      window.location.href = link.href;
    },

    onTagRemoveClick: function(evt) {
      evt.preventDefault();
      window.location.href = evt.currentTarget.href;
    }
  });

  return CollectionFilters;
})();

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  new theme.CollectionFilters();
});
